module.exports = require("core-js/library/fn/object/values");


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime-corejs2@7.9.2@@babel/runtime-corejs2/core-js/object/values.js
// module id = 2472
// module chunks = 0